import { createFormAction } from "redux-form-saga";
export const TRANSFER_FORM_KEY = 'ASSET_TRANSFER_FORM'
export const AssetTransferFormAction = createFormAction(TRANSFER_FORM_KEY)

